<template>
    <a-modal
        title="关联教材"
        width="70%"
        :visible="visible"
        :confirm-loading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel">
        <div class="search-box">
            <p>教材名：</p>
            <a-input class="input-box" v-model="searchFrom.name" />
            <a-button type="primary" icon="search" @click="fetch">搜索</a-button>
        </div>
        <a-table 
            rowKey='id'
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="false"
            :scroll="{ y: 500 }"
            :row-selection="{ selectedRowKeys: sub.textbookIdList, onChange: onSelectChange }"
            bordered>
        </a-table>
    </a-modal>
</template>

<script>
    import { relate,books } from '@/baseAPI/undergraduate/culture/course'
    import { listAll } from '@/baseAPI/undergraduate/culture/teaching'
    const columns = [
        {
            title: '序号',
            align:'center',
            width:70,
            fixed: 'left',
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '教材名称',
            dataIndex: 'name',
            align:'center',
        },
        {
            title: '作者',
            dataIndex: 'author',
            align:'center',
        },
        {
            title: '出版社',
            dataIndex: 'press',
            align:'center'
        },
        {
            title: '版次',
            dataIndex: 'edition',
            align:'center'
        },
    ];
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                visible: false,
                confirmLoading: false,
                columns,
                data:[],
                loading: false,
                searchFrom:{
                    name: '',
                },
                sub:{
                    courseInfoId:'',
                    textbookIdList:[]
                
                }
            }
        },
        mounted () {
        },
        methods:{
            showModal(id,type) {
                this.visible = true;
                books(id).then(res=>{
                    this.sub.courseInfoId=id;
                    this.sub.textbookIdList=[];
                    for(let i=0;i<res.data.length;i++){
                        this.sub.textbookIdList.push(res.data[i].id)
                    }
                    if(type=='gl'){
                        this.fetch();
                    }else{
                        this.data=res.data;
                    }
                })
            },
            fetch() {
                this.loading = true;
                listAll(this.searchFrom).then(res=>{
                    this.data = res.data;
                    this.loading = false;
                })
            },
            handleOk() {
                this.confirmLoading = true;
                relate(this.sub).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'关联教材成功',
                        });
                        this.visible = false;
                        this.confirmLoading = false;
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
                setTimeout(() => {
                }, 2000);
            },
            handleCancel() {
                this.visible = false;
            },
            onSelectChange(selectedRowKeys) {
                this.sub.textbookIdList = selectedRowKeys;
            },
        }
    }
</script>

<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
</style>
